import { render, staticRenderFns } from "./addFileModel.vue?vue&type=template&id=ad13bcd0&scoped=true"
import script from "./addFileModel.vue?vue&type=script&lang=js"
export * from "./addFileModel.vue?vue&type=script&lang=js"
import style0 from "./addFileModel.vue?vue&type=style&index=0&id=ad13bcd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad13bcd0",
  null
  
)

export default component.exports